import { cloneDeep } from 'lodash';

const group = {
  good_effect: {
    key: 'good_effect',
    name: '转化效果',
    children: []
  },

  impression_click_cost: {
    key: 'impression_click_cost',
    name: '点击、展现、消费',
    children: []
  },
  account_statistics: {
    key: 'account_statistics',
    name: '账户统计',
    children: []
  }
};

export function compose(data) {
  const arr = [];
  const _group = cloneDeep(group);
  for (let key in data) {
    const groupInfo = _group[key];
    if (groupInfo) {
      groupInfo.children = data[key];
      arr.push(groupInfo);
    } else {
      arr.push(data[key]);
    }
  }
  return arr;
}

export default group;
